import Utils from '@/views/org-dashboard/users/components/OrganiGram/src/utility.js';
import allFunctionalSkills from "@/assets/data/all-skills.js";
import allSoftSkills from "@/assets/data/all-personality.js";

const AIGenerateIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiM2YjcyODciPjxwYXRoIGQ9Ik00MDAtMTIwdi04MGgtODB2LTgwaDgwdi04MGg4MHY4MGg4MHY4MGgtODB2ODBoLTgwWm0xMjAtMjQwLTgwLTE2MC0xNjAtODAgMTYwLTgwIDgwLTE2MCA4MCAxNjAgMTYwIDgwLTE2MCA4MC04MCAxNjBaTTEyMC02ODBsLTQwLTgwLTgwLTQwIDgwLTQwIDQwLTgwIDQwIDgwIDgwIDQwLTgwIDQwLTQwIDgwWiIvPjwvc3ZnPg==";
const API_BASE_URL = process.env.VUE_APP_API_URL;

// Inject CSS for the AI spinning animation & custom scrollbar for dark dropdowns
if (!document.getElementById('role-popup-styles')) {
    const style = document.createElement('style');
    style.id = 'role-popup-styles';
    style.innerHTML = `
        @keyframes ai-spin { 100% { transform: rotate(360deg); } } 
        .ai-spinning { animation: ai-spin 1s linear infinite; }
        .dark-dropdown::-webkit-scrollbar { width: 6px; }
        .dark-dropdown::-webkit-scrollbar-track { background: #111; border-radius: 4px; }
        .dark-dropdown::-webkit-scrollbar-thumb { background: #444; border-radius: 4px; }
        .dark-dropdown::-webkit-scrollbar-thumb:hover { background: #666; }
    `;
    document.head.appendChild(style);
}

const RolePopupManager = {
    showToast(message, type = 'error') {
        let container = document.getElementById('role-toast-container');
        if (!container) {
            container = document.createElement('div');
            container.id = 'role-toast-container';
            Object.assign(container.style, {
                position: 'fixed', bottom: '24px', right: '24px', zIndex: '9999999', 
                display: 'flex', flexDirection: 'column', gap: '10px'
            });
            document.body.appendChild(container);
        }

        const toast = document.createElement('div');
        Object.assign(toast.style, {
            background: type === 'error' ? '#EF4444' : '#10B981', // Red for error, Green for success
            color: '#fff', padding: '14px 20px', borderRadius: '8px', fontSize: '14px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', gap: '10px',
            transform: 'translateX(120%)', opacity: '0', transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)', 
            fontWeight: '600', fontFamily: 'inherit'
        });
        
        const icon = type === 'error' 
            ? `<svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>` 
            : `<svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path></svg>`;

        toast.innerHTML = `${icon} <span>${message}</span>`;
        container.appendChild(toast);

        // Slide in
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                toast.style.transform = 'translateX(0)';
                toast.style.opacity = '1';
            });
        });

        // Remove after 3.5 seconds
        setTimeout(() => {
            toast.style.transform = 'translateX(120%)';
            toast.style.opacity = '0';
            setTimeout(() => toast.remove(), 300);
        }, 3500);
    },

    createModalOverlay() {
        const overlay = Utils.createElem("div", [], "role-design-overlay");
        Utils.applyStyles(overlay, {
            position: "fixed", top: "0", left: "0", width: "100%", height: "100%",
            background: "rgba(0,0,0,0.4)", zIndex: "999999", display: "flex",
            alignItems: "center", justifyContent: "center", backdropFilter: "blur(2px)"
        });
        return overlay;
    },

    closeOverlay(overlay) {
        if (overlay && document.body.contains(overlay)) {
            overlay.remove();
        }
    },

    showConfirmMovePopup(draggedName, targetName, onConfirm) {
        const overlay = RolePopupManager.createModalOverlay();
        const wrapper = Utils.createElem("div");
        Utils.applyStyles(wrapper, {
            background: "#fff", padding: "24px", borderRadius: "12px", width: "420px", 
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)", textAlign: "left", fontFamily: "inherit"
        });

        const icon = Utils.createElem("div", [], "", "⚠️");
        Utils.applyStyles(icon, { fontSize: "28px", marginBottom: "10px" });

        const title = Utils.createElem("h3", [], "", "Change Reporting Line?");
        Utils.applyStyles(title, { margin: "0 0 8px 0", color: "#111", fontSize: "18px", fontWeight: "600" });

        const desc = Utils.createElem("p", [], "", `Are you sure you want to move <b>${draggedName}</b> to report under <b>${targetName}</b>?`);
        Utils.applyStyles(desc, { margin: "0 0 20px 0", color: "#555", fontSize: "14px", lineHeight: "1.6" });

        const btnRow = Utils.createElem("div");
        Utils.applyStyles(btnRow, { display: "flex", justifyContent: "flex-end", gap: "10px" });

        const cancelBtn = Utils.createElem("button", [], "", "Cancel");
        Utils.applyStyles(cancelBtn, { background: "#f1f5f9", color: "#334155", border: "none", padding: "10px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "600" });
        cancelBtn.onclick = () => RolePopupManager.closeOverlay(overlay);

        const confirmBtn = Utils.createElem("button", [], "", "Yes, Move it");
        Utils.applyStyles(confirmBtn, { background: "#ffc107", color: "#000", border: "none", padding: "10px 24px", borderRadius: "6px", cursor: "pointer", fontWeight: "600" });
        confirmBtn.onclick = () => { RolePopupManager.closeOverlay(overlay); onConfirm(); };

        btnRow.append(cancelBtn, confirmBtn);
        wrapper.append(icon, title, desc, btnRow);
        overlay.append(wrapper);
        document.body.appendChild(overlay);
    },

    showDeleteRolePopup(node, subRolesCount, assignedCount, onConfirm) {
        const overlay = RolePopupManager.createModalOverlay();
        const wrapper = Utils.createElem("div");
        Utils.applyStyles(wrapper, { background: "#fff", padding: "24px", borderRadius: "12px", width: "480px", boxShadow: "0 10px 25px rgba(0,0,0,0.2)", textAlign: "left", fontFamily: "inherit" });

        let contentHTML = "";

        if (subRolesCount > 0) {
            contentHTML = `
                <div style="display:flex; gap:14px; padding:14px; border-radius:10px; background:#fdecea; align-items:flex-start;">
                    <span style="font-size:24px; line-height:1; color:#d32f2f;">⚠️</span>
                    <div>
                        <h3 style="margin:0 0 6px; font-size:17px; font-weight:600; color:#b71c1c;">Sub-roles detected</h3>
                        <p style="margin:0; font-size:14px; color:#c62828; line-height:1.4;">This role has <b>${subRolesCount}</b> connected sub-role(s).</p>
                    </div>
                </div>
                <p style="margin:14px 0 0; font-size:14px; color:#555; line-height:1.6;">Deleting this role will <b>permanently remove</b> all sub-roles and unassign all candidates.</p>
            `;
        } else if (assignedCount > 0) {
            contentHTML = `
                <div style="display:flex; gap:14px; padding:14px; border-radius:10px; background:#fff4e5; align-items:flex-start;">
                    <span style="font-size:24px; line-height:1; color:#f57c00;">⚠️</span>
                    <div>
                        <h3 style="margin:0 0 6px; font-size:17px; font-weight:600; color:#e65100;">Active assignments</h3>
                        <p style="margin:0; font-size:14px; color:#ef6c00; line-height:1.4;"><b>${assignedCount}</b> candidate(s) are currently assigned.</p>
                    </div>
                </div>
                <p style="margin:14px 0 0; font-size:14px; color:#555; line-height:1.6;">Deleting this role will remove all assignments from the chart.</p>
            `;
        } else {
            contentHTML = `
                <div style="display:flex; gap:14px; padding:14px; border-radius:10px; background:#f5f5f5; align-items:flex-start;">
                    <span style="font-size:24px; line-height:1; color:#616161;">⚠️</span>
                    <div>
                        <h3 style="margin:0 0 6px; font-size:17px; font-weight:600; color:#424242;">Delete role?</h3>
                        <p style="margin:0; font-size:14px; color:#616161; line-height:1.4;">This role will be removed from the organization chart.</p>
                    </div>
                </div>
            `;
        }

        const msgContainer = Utils.createElem("div");
        msgContainer.innerHTML = contentHTML + `<p style="margin-top:14px; margin-bottom:20px; font-size:14px; font-weight:600; color:#333;">This action cannot be undone.</p>`;

        const btnRow = Utils.createElem("div");
        Utils.applyStyles(btnRow, { display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "10px" });

        const cancelBtn = Utils.createElem("button", [], "", "Cancel");
        Utils.applyStyles(cancelBtn, { background: "#f1f5f9", color: "#334155", border: "none", padding: "10px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "600" });
        cancelBtn.onclick = () => RolePopupManager.closeOverlay(overlay);

        const confirmBtn = Utils.createElem("button", [], "", "Confirm Delete");
        Utils.applyStyles(confirmBtn, { background: "#dc3545", color: "#fff", border: "none", padding: "10px 24px", borderRadius: "6px", cursor: "pointer", fontWeight: "600" });
        confirmBtn.onclick = () => { 
            RolePopupManager.closeOverlay(overlay); 
            onConfirm(); 
            RolePopupManager.showToast("Role deleted successfully", "success");
        };

        btnRow.append(cancelBtn, confirmBtn);
        wrapper.append(msgContainer, btnRow);
        overlay.append(wrapper);
        document.body.appendChild(overlay);
    },

    showCreateOrEditPopup(mode, nodeData, onSave) {
        const overlay = RolePopupManager.createModalOverlay();
        
        let currentSkills = Array.isArray(nodeData.skills) ? [...nodeData.skills] : [];
        let currentSoftSkills = Array.isArray(nodeData.softSkills) ? [...nodeData.softSkills] : [];

        // Parse backend Description schema properly: array of objects with "msg" property
        let initialDesc = "";
        if (Array.isArray(nodeData.description) && nodeData.description.length > 0) {
            // Find the most relevant description text, stripping out the system tag
            const descObj = nodeData.description.find(d => d.msg && d.msg.includes('[ROLE_DESC_SAVE]')) || nodeData.description[0];
            if (descObj && descObj.msg) {
                initialDesc = descObj.msg.replace("[ROLE_DESC_SAVE] ", "").trim();
            }
        } else if (typeof nodeData.description === 'string') {
            initialDesc = nodeData.description.replace("[ROLE_DESC_SAVE] ", "").trim();
        } else if (nodeData.roleSummary) {
            initialDesc = nodeData.roleSummary;
        }

        const safeFuncSkillsData = Array.isArray(allFunctionalSkills) ? allFunctionalSkills : [];
        const safeSoftSkillsData = Array.isArray(allSoftSkills) ? allSoftSkills : [];

        const wrapper = Utils.createElem("div");
        Utils.applyStyles(wrapper, {
            background: "#fff", borderRadius: "12px", width: "750px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.15)", display: "flex", flexDirection: "column",
            fontFamily: "inherit", padding: "24px", boxSizing: "border-box"
        });

        // --- HEADER ---
        const headerRow = Utils.createElem("div");
        Utils.applyStyles(headerRow, { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" });
        
        const headerTitle = Utils.createElem("h2", [], "", mode === 'EDIT' ? nodeData.title || "Edit Role" : "Create Role");
        Utils.applyStyles(headerTitle, { margin: "0", fontSize: "20px", fontWeight: "700", color: "#111" });
        
        const iconsGroup = Utils.createElem("div");
        Utils.applyStyles(iconsGroup, { display: "flex", alignItems: "center", gap: "16px" });
        
        const bookmarkIcon = Utils.createElem("span");
        bookmarkIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>`;
        Utils.applyStyles(bookmarkIcon, { cursor: "pointer", display: "flex", alignItems: "center" });

        const closeBtn = Utils.createElem("span");
        closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`;
        Utils.applyStyles(closeBtn, { cursor: "pointer", display: "flex", alignItems: "center" });
        closeBtn.onclick = () => RolePopupManager.closeOverlay(overlay);
        
        iconsGroup.append(bookmarkIcon, closeBtn);
        headerRow.append(headerTitle, iconsGroup);

        // --- DESIGNATION INPUT ---
        const titleInput = Utils.createElem("input");
        titleInput.placeholder = "Designation";
        titleInput.value = nodeData.title || "";
        Utils.applyStyles(titleInput, { 
            width: "100%", padding: "0 0 8px 0", fontSize: "16px", fontWeight: "700", 
            color: "#6B7280", border: "none", outline: "none", marginBottom: "20px" 
        });

        // --- SKILLS SECTION ---
        const skillsMainBox = Utils.createElem("div");
        Utils.applyStyles(skillsMainBox, { 
            display: "flex", border: "1px solid #E5E7EB", borderRadius: "10px" 
        });

        const createSkillCol = (label, skillArray, isLeftCol, suggestionData) => {
            const col = Utils.createElem("div");
            Utils.applyStyles(col, { 
                flex: "1", display: "flex", flexDirection: "column", padding: "16px", 
                borderRight: isLeftCol ? "1px solid #E5E7EB" : "none" 
            });

            const lbl = Utils.createElem("div", [], "", label);
            Utils.applyStyles(lbl, { fontSize: "14px", fontWeight: "700", marginBottom: "16px", color: "#111" });

            const inputWrapper = Utils.createElem("div");
            Utils.applyStyles(inputWrapper, { 
                position: "relative", display: "flex", alignItems: "center", borderBottom: "1px solid #E5E7EB", paddingBottom: "6px" 
            });

            const input = Utils.createElem("input");
            input.placeholder = label;
            Utils.applyStyles(input, { 
                width: "100%", border: "none", outline: "none", fontSize: "14px", color: "#374151", background: "transparent"
            });

            const arrowIcon = Utils.createElem("span", [], "", "▼");
            Utils.applyStyles(arrowIcon, { fontSize: "10px", color: "#111", pointerEvents: "none", marginLeft: "8px" });

            // Dropdown List Container
            const dropdown = Utils.createElem("div", ["dark-dropdown"]);
            Utils.applyStyles(dropdown, {
                position: "absolute", top: "100%", left: "0", width: "100%", maxHeight: "220px", overflowY: "auto", 
                background: "#050505", color: "#fff", zIndex: "9999", display: "none",
                boxShadow: "0 10px 30px rgba(0,0,0,0.5)", marginTop: "4px", borderRadius: "6px", border: "1px solid #222"
            });

            const pillsBox = Utils.createElem("div");
            Utils.applyStyles(pillsBox, { 
                display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "16px", 
                height: "110px", overflowY: "auto", alignContent: "flex-start" 
            });

            const renderPills = () => {
                pillsBox.innerHTML = "";
                skillArray.forEach(sk => {
                    const pill = Utils.createElem("span", [], "", sk);
                    Utils.applyStyles(pill, { 
                        background: "#fff", color: "#4B5563", padding: "4px 10px", borderRadius: "16px", 
                        fontSize: "12px", display: "flex", alignItems: "center", gap: "6px", 
                        border: "1px solid #E5E7EB", boxShadow: "0 1px 2px rgba(0,0,0,0.03)" 
                    });
                    
                    const del = Utils.createElem("span", [], "", "×");
                    Utils.applyStyles(del, { color: "#9CA3AF", cursor: "pointer", fontSize: "16px", lineHeight: "1" });
                    del.onclick = () => { skillArray.splice(skillArray.indexOf(sk), 1); renderPills(); };
                    
                    pill.append(del);
                    pillsBox.append(pill);
                });
            };

            const renderDropdown = (filterText) => {
                dropdown.innerHTML = "";
                
                const extractString = (val) => typeof val === 'string' ? val : (val.name || val.title || String(val));
                
                const filtered = suggestionData.filter(s => {
                    const strVal = extractString(s);
                    return strVal.toLowerCase().includes(filterText.toLowerCase()) && !skillArray.includes(strVal);
                });

                if (filtered.length === 0) {
                    const noItem = Utils.createElem("div", [], "", "No results found");
                    Utils.applyStyles(noItem, { padding: "10px 14px", fontSize: "13px", color: "#666", fontStyle: "italic" });
                    dropdown.appendChild(noItem);
                    return;
                }

                filtered.forEach(item => {
                    const strVal = extractString(item);
                    const div = Utils.createElem("div", [], "", strVal);
                    Utils.applyStyles(div, {
                        padding: "10px 14px", fontSize: "13px", cursor: "pointer", borderBottom: "1px solid #1a1a1a", color: "#eee"
                    });
                    
                    div.onmouseover = () => div.style.background = "#222";
                    div.onmouseout = () => div.style.background = "transparent";
                    
                    div.onmousedown = (e) => { 
                        e.preventDefault();
                        if (!skillArray.includes(strVal)) skillArray.push(strVal);
                        input.value = "";
                        dropdown.style.display = "none";
                        renderPills();
                    };
                    dropdown.appendChild(div);
                });
            };

            input.onfocus = () => {
                renderDropdown(input.value);
                dropdown.style.display = "block";
            };

            input.onblur = () => {
                setTimeout(() => { dropdown.style.display = "none"; }, 150);
            };

            input.oninput = (e) => {
                renderDropdown(e.target.value);
                dropdown.style.display = "block";
            };

            input.onkeydown = (e) => {
                if(e.key === 'Enter' && input.value.trim()) {
                    e.preventDefault();
                    let items = input.value.split(',').map(i => i.trim()).filter(i => i);
                    items.forEach(i => { if(!skillArray.includes(i)) skillArray.push(i); });
                    input.value = "";
                    dropdown.style.display = "none";
                    renderPills();
                }
            };

            inputWrapper.append(input, arrowIcon, dropdown);
            renderPills();
            
            col.append(lbl, inputWrapper, pillsBox);
            return { col, input, renderPills };
        };

        const funcSkills = createSkillCol("Functional Skills", currentSkills, true, safeFuncSkillsData);
        const softSkillsBox = createSkillCol("Soft Skills", currentSoftSkills, false, safeSoftSkillsData);
        skillsMainBox.append(funcSkills.col, softSkillsBox.col);

        // --- ROLE DESCRIPTION SECTION ---
        const descSection = Utils.createElem("div");
        Utils.applyStyles(descSection, { marginTop: "24px" });

        const descHeader = Utils.createElem("div");
        Utils.applyStyles(descHeader, { display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px" });
        
        const descLabel = Utils.createElem("div", [], "", "Role Description");
        Utils.applyStyles(descLabel, { 
            background: "#EAD038", padding: "6px 14px", borderRadius: "6px", 
            fontSize: "13px", fontWeight: "700", color: "#000" 
        });
        
        const chatIcon = Utils.createElem("div");
        chatIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>`;
        Utils.applyStyles(chatIcon, { display: "flex", alignItems: "center" });
        descHeader.append(descLabel, chatIcon);

        const descContainer = Utils.createElem("div");
        Utils.applyStyles(descContainer, { 
            position: "relative", border: "1px solid #E5E7EB", borderRadius: "10px", padding: "16px" 
        });
        
        const descInput = Utils.createElem("textarea");
        descInput.placeholder = "Enter Role Description...";
        descInput.value = initialDesc; // Initialize with properly parsed description
        Utils.applyStyles(descInput, { 
            width: "100%", height: "130px", border: "none", outline: "none", 
            resize: "none", fontFamily: "inherit", fontSize: "14px", color: "#374151", boxSizing: "border-box" 
        });

        const aiBtn = Utils.createElem("button");
        Utils.applyStyles(aiBtn, { 
            position: "absolute", top: "16px", right: "16px", background: "#F3F4F6", 
            border: "none", borderRadius: "50%", width: "34px", height: "34px", 
            cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" 
        });
        aiBtn.innerHTML = `<img src="${AIGenerateIcon}" style="width:18px; height:18px;" />`;
        aiBtn.title = "Use AI to generate description";

        aiBtn.onclick = async () => {
            if (!titleInput.value) {
                RolePopupManager.showToast("Please enter a Designation first.", "error");
                return;
            }
            
            aiBtn.classList.add('ai-spinning'); 

            try {
                const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                
                const payload = {
                    role_id: mode === 'EDIT' ? (nodeData.id || "new_role") : "new_role",
                    role_title: titleInput.value,
                    technical_skills: currentSkills,
                    soft_skills: currentSoftSkills,
                    existing_description: descInput.value
                };

                const res = await fetch(`${API_BASE_URL}/api/generate-role-description`, {
                    method: 'POST', 
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                    body: JSON.stringify(payload)
                });

                if (!res.ok) throw new Error("API failed to generate description.");
                
                const data = await res.json();
                descInput.value = data.description || data.role_summary || "";
                
                if (data.recommended_technical_skills) {
                    data.recommended_technical_skills.forEach(s => { if(!currentSkills.includes(s)) currentSkills.push(s); });
                    funcSkills.renderPills();
                }
                if (data.recommended_soft_skills) {
                    data.recommended_soft_skills.forEach(s => { if(!currentSoftSkills.includes(s)) currentSoftSkills.push(s); });
                    softSkillsBox.renderPills();
                }

                wordCount.innerText = `${descInput.value.length}/2500`;
                RolePopupManager.showToast("Description generated successfully!", "success");

            } catch(e) { 
                console.error("AI Error", e); 
                RolePopupManager.showToast("Failed to generate description. Please try again.", "error");
            } finally { 
                aiBtn.classList.remove('ai-spinning'); 
            }
        };

        descContainer.append(descInput, aiBtn);
        descSection.append(descHeader, descContainer);

        // --- FOOTER SECTION ---
        const footerContainer = Utils.createElem("div");
        Utils.applyStyles(footerContainer, { 
            display: "flex", flexDirection: "column", alignItems: "flex-end", marginTop: "16px", gap: "8px" 
        });

        const wordCount = Utils.createElem("span", [], "", `${descInput.value.length}/2500`);
        Utils.applyStyles(wordCount, { fontSize: "12px", color: "#9CA3AF" });

        descInput.oninput = () => {
            wordCount.innerText = `${descInput.value.length}/2500`;
        };

        const saveBtn = Utils.createElem("button", [], "", mode === 'EDIT' ? "Save Changes" : "Create Role");
        Utils.applyStyles(saveBtn, { 
            background: "#EAD038", color: "#000", border: "none", padding: "10px 24px", 
            borderRadius: "6px", cursor: "pointer", fontWeight: "700", fontSize: "15px" 
        });
        
        saveBtn.onclick = () => {
            if (!titleInput.value) {
                RolePopupManager.showToast("Please enter a Designation first.", "error");
                return;
            }

            saveBtn.disabled = true;
            saveBtn.innerText = "Saving...";
            
            // Format the payload exactly to match the backend FeathersJS kvdr-role API Schema
            const payload = {
                ...nodeData, // Keep existing node data IDs intact
                title: titleInput.value,
                skills: currentSkills,
                softSkills: currentSoftSkills,
                // The API stores description as an array of objects
                description: [
                    { msg: `[ROLE_DESC_SAVE] ${descInput.value}` }
                ],
                roleSummary: descInput.value // Keep as secondary fallback for UI libraries
            };

            onSave(payload);
            
            //RolePopupManager.showToast(mode === 'EDIT' ? "Role updated successfully!" : "Role created successfully!", "success");
            RolePopupManager.closeOverlay(overlay);
        };

        footerContainer.append(wordCount, saveBtn);

        wrapper.append(headerRow, titleInput, skillsMainBox, descSection, footerContainer);
        overlay.append(wrapper);
        document.body.appendChild(overlay);
    }
};

export default RolePopupManager;
